import { render, staticRenderFns } from "./entrega-elementos-editar.vue?vue&type=template&id=5753e552&"
import script from "./entrega-elementos-editar.vue?vue&type=script&lang=js&"
export * from "./entrega-elementos-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports